import TimeCounter from './TimeCounter';

export default TimeCounter;